import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { Icon } from '../Icon/Icon.js';
import { ImgAsPicture } from './ImgAsPicture.js';
export const Img = JSX(({ className = '', image, imageClassName = '', ...iconProps }) => {
    if (!image?.src && !image?.icon) {
        return null;
    }
    return image.icon ? (_jsx(Icon, { className: className, imageClassName: imageClassName, iconVersion: image?.iconVersion, name: image.icon, ...iconProps })) : (_jsx(ImgAsPicture, { className: className, imageClassName: imageClassName, image: image }));
});
//# sourceMappingURL=Img.js.map